import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH } from "../../../../utils/Constants";
import {
  handleServerValidations,
  DT,
  globalLoader
} from "../../../../utils/commonfunction";
import GoogleAddressInput from "./cafeAddressField"; // adjust relative path
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { Details, Edit } from "../../services/usermgmt.services";
import { cuisineOptions } from "../../../../utils/Constants";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";


const UserEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");
  const [saveType, setSaveType] = useState("");
  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard" },
    {
      title:  t("admin.cafes.link_cafes"),
      url: "/admin/cafe-management/cafe/list/1",
    },
    { title: t("admin.cafes.link_edit"), url: "" },
  ];

  useEffect(() => {
    Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setPreviewImage(response.data.cafe_logo);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  const validationSchema = Yup.object().shape({
    cafe_name: Yup.string().trim().max(150, "admin.cafes.max_length_error").required("admin.cafes.label_trading_name_error"),
    // cafe_name: Yup.string().trim().max(100,"max_length_error").required(("label_restaurant_name_error")),
    email: Yup.string()
      .trim()
      .required("admin.cafes.label_email_required_error")
      .email("admin.cafes.label_email_invalid_format_error")
      .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/, "admin.cafes.label_email_invalid_format_error")
      // .test('no-uppercase', "admin.cafes.label_email_uppercase_error", function (value) {
      //   if (value) {
      //     return !/[A-Z]/.test(value);
      //   }
      // }),,
      ,
    phone_number: PHONE_VALIDATION,
    address: Yup.string().max(TEXTAREA_MAX_LENGTH, "admin.cafes.validation_max_input_characters").required("admin.cafes.label_location_error"),
    cafe_logo: Yup.mixed()
    .nullable()
    .test(
      'fileOrUrl',
     'admin.cafes.supported_file_error',
      value => {
        if (!value) return true; 
        if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
        return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
      }
    )
    .test(
      'fileSize',
      'admin.cafes.image_max_size_error',
      value => {
        if (!value || typeof value === 'string') return true;
        return value.size <= 1.5 * 1024 * 1024;
      }
    )
    .test(
      'validImage',
      'Upload a valid image',
      value =>
        new Promise(resolve => {
          if (!value || typeof value === 'string') return resolve(true);

          const reader = new FileReader();
          reader.onload = () => {
            const img = new Image();
            img.onload = () => resolve(true); 
            img.onerror = () => resolve(false);
            img.src = reader.result;
          };
          reader.onerror = () => resolve(false);
          reader.readAsDataURL(value);
        })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cafe_name: showdefault && showdefault.cafe_name ? showdefault.cafe_name : "",
      email: showdefault && showdefault.email ? showdefault.email : "",
      phone_number: showdefault && showdefault?.phone_number ? showdefault?.phone_number : "",
      address: showdefault && showdefault.address ? showdefault.address : "",
      cafe_logo: showdefault && showdefault.cafe_logo ? showdefault.cafe_logo : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("o_id", params.id);
      formData.append("cafe_name", values.cafe_name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      formData.append("address", values.address);
      formData.append("cafe_logo", values.cafe_logo);
      Edit(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/cafe-management/cafe/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("admin.cafes.edit_heading_edit_cafe")}
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="cafe_name" className="text-left d-flex">
                    {t("admin.cafes.label_trading_name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="cafe_name"
                      id="cafe_name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cafe_name}
                      className="form-control"
                      placeholder={t("admin.cafes.placeholder_trading_name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_MAX_25]} name="cafe_name" form={formik} />
                    </span>
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                    {t("admin.cafes.label_email")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="email"
                      id="email"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      className="form-control"
                      placeholder={t("admin.cafes.placeholder_email")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>

                  <GoogleAddressInput formik={formik} t={t} />

                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex" htmlFor="phone_number">
                    {t("admin.cafes.label_phone_number")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <PhoneInput
                      name="phone_number"
                      id="phone_number"
                      placeholder={t('admin.cafes.placeholder_phone_number')}
                      onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone_number}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>

                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="restaurant_logo" className="text-left d-flex">
                    {t("admin.cafes.label_logo")}:
                      {" "}
                      <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("admin.cafes.image_support_tooltip")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="cafe_logo"
                      name="cafe_logo"
                      accept="image/*"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "cafe_logo",
                          event.target.files[0] || ""
                        );
                        event.target.files.length === 1
                          ? setPreviewImage(
                            URL.createObjectURL(event.target.files[0])
                          )
                          : setPreviewImage("");
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="cafe_logo" form={formik} />
                    </span>
                    {previewimage ? (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          <img
                            src={previewimage}
                            style={{ height: "100px" }}
                            alt={"profileImg"}
                          />
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserEdit;